import { render, staticRenderFns } from "./CreditorInfo.vue?vue&type=template&id=4b5de20a&scoped=true&"
import script from "./CreditorInfo.vue?vue&type=script&lang=js&"
export * from "./CreditorInfo.vue?vue&type=script&lang=js&"
import style0 from "./CreditorInfo.vue?vue&type=style&index=0&id=4b5de20a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5de20a",
  null
  
)

export default component.exports